export const rrules = [
  { label: "Daily", value: "FREQ=DAILY" },
  { label: "Weekly", value: "FREQ=WEEKLY" },
  { label: "Bi-weekly", value: "FREQ=WEEKLY;INTERVAL=2" },
  { label: "Monthly", value: "FREQ=MONTHLY" },
  { label: "Quarterly", value: "FREQ=MONTHLY;INTERVAL=3" },
  { label: "Yearly", value: "FREQ=YEARLY" },
] as const

export const rruleLabels = rrules.reduce(
  (acc, { label, value }) => {
    acc[value] = label
    return acc
  },
  {} as Record<string, string>,
)
